import { render, staticRenderFns } from "./code.vue?vue&type=template&id=f05f4d2a&scoped=true"
import script from "./code.vue?vue&type=script&lang=ts"
export * from "./code.vue?vue&type=script&lang=ts"
import style0 from "./code.vue?vue&type=style&index=0&id=f05f4d2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05f4d2a",
  null
  
)

export default component.exports